<template>
  <transition name="fade">
    <div
      v-if="notification"
      class="notification-bar alert text-white border-0 mb-4"
      :class="notificationTypeClass"
      role="alert"
    >
      <button
        type="button"
        class="close"
        aria-label="Close"
        v-show="notification?.is_dismissible"
        @click="destroyNotification"
      >
        <span aria-hidden="true">× </span>
      </button>
      <div v-html="notification?.message" />
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue'

import { useStore } from 'vuex'

import { eventEmitter } from '@/event-bus'

import { NOTIFICATION_SEVERITY_TYPE_CLASSES } from '@/constants/constants'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})

const store = useStore()

const notificationTypeClass = computed(() => {
  const typeClassName = NOTIFICATION_SEVERITY_TYPE_CLASSES[props.notification.type]
  let className = `alert-${typeClassName} bg-${typeClassName}`
  if (props.notification.is_dismissible) {
    className += ' alert-dismissible'
  }
  return className
})

const destroyNotification = () => {
  store.dispatch('notification/remove', props.notification)
  eventEmitter.emit('notificationRead', props.notification)
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
